import React, { useState } from "react";
import { useUser } from "../../core/contexts/UserProvider";
import Loading from "../../components/LoadingError/Loading";
import EmptyList from "../../components/EmptyList";
import { Link } from "react-router-dom";

const ProfilePage = () => {
  const { user } = useUser();

  const [posts, setPosts] = useState([]);

  return (
    <div className="relative bg-white px-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex space-x-10">
          <div className="flex-[3]">
            <div className="py-4 px-4 flex items-center justify-between sticky top-0 z-10 bg-white">
              <h1 className="text-3xl font-extrabold tracking-tight text-gray-900 py-6">
                {user?.firstName
                  ? `${user?.firstName} ${user?.lastName}`
                  : `${user?.email}`}
              </h1>
              <div className="flex items-center">
                {user?._id && (
                  <Link
                    className="text-black bg-white hover:bg-gray-600 hover:text-white px-4 py-2 rounded-full border shadow-sm"
                    to={`/profile/edit-profile`}
                  >
                    Modifier
                  </Link>
                )}
              </div>
            </div>

            {!user ? (
              <div className="mb-5">
                <Loading />
              </div>
            ) : (
              <>
                {posts.length > 0 ? (
                  <div className="my-[40px]"></div>
                ) : (
                  <EmptyList title="Aucunes informations" />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
